export enum ProductPostingMode {
    Once = 'Once',
    PerTimeUnit = 'PerTimeUnit',
}
